import { handleResponseOld, makeGet } from './helpers';
import type { FetchItemsCardModelsResponse } from '@/types/ItemCardModel';

/**
 * @category ItemCardModel API
 * @see fetchItemsByIds
 */
type FetchItemCardModelsByIdsParams = {
    authToken: string;
    deployment: string;
    identifier: string;
    itemIds: number[];
};

/**
 * @category ItemCardModel API
 * @see fetchItemsCardModelsByIds
 */

/**
 * Fetches item info by given item ids via Post to ItemCardModel service
 * @function fetchItemsCardModelsByIds
 * @category ItemCardModel API
 * @param {FetchItemsCardModelsByIdsParams}
 */

const fetchItemCardModelsByIds = ({ authToken, deployment, identifier, itemIds }: FetchItemCardModelsByIdsParams) =>
    new Promise<FetchItemsCardModelsResponse>((resolve: Function, reject: Function) => {
        const request = makeGet({ apiPath: 'items', authToken, deployment, path: '<ITEM-MODEL-API>' });
        request.query({ identifier, lotIds: itemIds.join(',') });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });

/**
 * Fetches item info by given item ids via Post to ItemCardModel service
 * @function fetchItemsCardModelsByCatalogId
 * @category ItemCardModel API
 * @param {FetchItemsCardModelsByIdsParams}
 */

export type FetchItemsCardModelsByCatalogIdQueryType = {
    buyNow?: boolean;
    index?: number;
    keyword?: string;
    page?: number;
    pageSize?: number | 'all';
    preview?: boolean;
    sort?: string;
};

type FetchItemsCardModelsByCatalogIdParams = {
    authToken: string;
    catalogId: number;
    deployment: string;
    query: FetchItemsCardModelsByCatalogIdQueryType;
};

const fetchItemsCardModelsByCatalogId = ({
    authToken,
    catalogId,
    deployment,
    query,
}: FetchItemsCardModelsByCatalogIdParams) =>
    new Promise<FetchItemsCardModelsResponse>((resolve: Function, reject: Function) => {
        const request = makeGet({ apiPath: `catalog/${catalogId}`, authToken, deployment, path: '<ITEM-MODEL-API>' });
        request.query(query);
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });

export default {
    fetchItemCardModelsByIds,
    fetchItemsCardModelsByCatalogId,
};
